"use client";

import type { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

import { withValidation } from "@/libs/builder/validators/validateBuilderComponentData";

export const ctaBlockInputs = [
  {
    name: "title",
    type: "string",
    required: true,
    helperText: "The title of the CTA block",
  },
  {
    name: "text",
    type: "string",
    required: true,
    helperText: "The descriptive text below the title",
  },
  {
    name: "ctaText",
    type: "string",
    required: true,
    helperText: "The text displayed on the button",
  },
  {
    name: "href",
    type: "url",
    required: true,
    helperText: "The URL the button links to",
  },
] as const satisfies Inputs;

export const CtaBlockComponent: RegisteredComponent = {
  name: "CTA Block",
  component: dynamic(async () => withValidation(ctaBlockInputs, (await import("./CtaBlock")).CtaBlock, "CtaBlock")),
  inputs: ctaBlockInputs,
};
